// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__3Jv4o","text_area":"form_text_area__vmXUX","success":"form_success__28rUQ"};